module.exports = __webpack_public_path__ + "img/care-bg.bb1b106b.png";